import React, { useContext } from "react"
import { i18nContext } from "../context/i18nContext"
import { UserContext } from "../context/userContext"
import { InboundLink } from "./link"
import supabase from "../services/supabase"
import { useAlert } from "react-alert"

const AuthButton = ({}) => {
  const user = useContext(UserContext)
  const alert = useAlert()

  const handleLogout = () => {
    supabase.auth.signOut()
    alert.show("You have been logged out")
  }
  return (
    <i18nContext.Consumer>
      {t => (
        <>
          {user && user.user ? (
            <InboundLink to="#" onClick={handleLogout}>
              logout
            </InboundLink>
          ) : (
            <InboundLink
              to="/login"
              sx={{
                backgroundColor: "light",
                color: "primary",
              }}
            >
              Login
            </InboundLink>
          )}
        </>
      )}
    </i18nContext.Consumer>
  )
}

export default AuthButton
